import { PostingChannel } from "../Posting/enums";

export function filterExpiredPlanning(posting: Posting, expirationDate?: Date) {
    if (posting.channel === PostingChannel.PLANNING && undefined !== expirationDate) {
        return posting.receiptDate > expirationDate;
    }
    return true;
}
